import { render, staticRenderFns } from "./getAppTable.vue?vue&type=template&id=e28813d2"
import script from "./getAppTable.vue?vue&type=script&lang=js"
export * from "./getAppTable.vue?vue&type=script&lang=js"
import style0 from "./getAppTable.vue?vue&type=style&index=0&id=e28813d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports